import { HTTP,handleSessionExpired } from '../../utils'

export const getCourseDetail = (uuid) => {
  return HTTP().get('deliverycontext/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    handleSessionExpired(e)
    console.log(e)
  })
}
export const getCheckBrokenLinks = (uuid) => {
  return HTTP().get('deliverycontext/' + uuid+'/brokenlink')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const askSuggestForContinueLearning = (uuid) => {
  return HTTP().get('suggest/course/' + uuid + '/last')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const scormLaunchURL = (entity) => {
  let hostname = window.location.hostname
  if (hostname) {
    hostname += '/vue'
  }
  let url = '/scorm/registration?scormId=' + entity.scormId + '&assetId=' + entity.uuid + '&courseId=' + entity.courseId + '&hostname=' + hostname
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const scormLaunchURLWithToken = (entity) => {
  let hostname = window.location.hostname
  if (hostname) {
    hostname += '/vue'
  }
  let url = '/scorm/registration?scormId=' + entity.scormId + '&assetId=' + entity.assetId + '&courseId=' + entity.courseId + '&hostname=' + hostname
  return HTTP(entity.token).get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const scormPreviewURL = (entity) => {
  let hostname = window.location.hostname
  if (hostname) {
    hostname += '/vue'
  }
  let url = '/scorm/generatePreviewUrl?scormId=' + entity.scormId + '&hostname=' + hostname
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const askSuggestForLast = (uuid) => {
  return HTTP().get('suggest/course/' + uuid + '/lastaction')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const addPrePostCompetency = (courseId, position, data) => {
  let url = '/competency/add/course/'+courseId+'/position/'+position
  return HTTP().put(url, data)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}
export const addReleaseLogicForMCs = (courseId, type, unlockDate) => {
  let url = '/deliverycontext/'+courseId+'/releaselogic/'+type+'?unlockDate='+unlockDate
  return HTTP().put(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}
export const addReleaseLogicForMicroCompetency = (courseId, mcId, type, depndesOn) => {
  let url = '/deliverycontext/addlogic/'+mcId+'/course/'+courseId+'/type/'+type+'/on/'+depndesOn
  return HTTP().put(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}

export const getCourseTopics = (uuid) => {
  return HTTP().put('deliverycontext/' + uuid + '/withPlan')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const getCompetencyTopics = (courseId, mcId) => {
  return HTTP().get('deliverycontext/' + courseId + '/competencies/'+mcId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const getMicroCompetencyTopics = (courseId, mcId) => {
  return HTTP().get('deliverycontext/' + courseId + '/microcompetencies/'+mcId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCourseMicroCompetencies = (competencyId) => {
  return HTTP().get('competency/' + competencyId + '/children')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getLearningTopicDetails = (uuid) => {
  return HTTP().get('topic/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getLearningContentDetails = (uuid) => {
  return HTTP().get('learningcontent/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getScormDetails = (uuid, token) => {
  return HTTP(token).get('learningActivityEvent/scormdone/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const askSuggestForNext = (courseUuid, entityUuid) => {
  return HTTP().get('suggest/course/' + courseUuid + '/next/' + entityUuid)
  .then(response => {
    console.log('suggest data: ', response.data)
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getMicroCompetencySummary = (entityId) => {
  var url = 'competency/' + entityId + '/mcSummary'
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getMicroCompetencySummaryForSelectedUser = (entityId, userId) => {
  var url = 'competency/' + entityId + '/mcSummary/' + userId
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCompetencySummary = (entityId) => {
  var url = 'competency/' + entityId + '/competencySummary'
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCompetencySummaryForSelectedUser = (entityId, userId) => {
  var url = 'competency/' + entityId + '/competencySummary/' + userId
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCourseGradeForClass = (courseId) => {
  return HTTP().get('competency/' + courseId + '/competencySummary/class')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCourseCompetencies = (courseId) => {
  return HTTP().get('competency/' + courseId + '/competencySummary')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const saveRating = (ratingInfo) => {
  return HTTP().put('rating', ratingInfo)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getClassSummary = (courseId) => {
  return HTTP().get('/class/' + courseId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getClassSummaryWithPeer = (entityId, userId) => {
  let url = 'class/' + entityId + '/peer'
  if (userId) {
    url += '?userId=' + userId
  }
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getChildrenSummary = (courseId, competencyId, userId) => {
  let url = 'competency/' + courseId + '/competencySummary/competency/' + competencyId + '/children/withparent'
  if (userId) {
    url += '?userId=' + userId
  }
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const startLearningActivity = (activity) => {
  return HTTP().put('learningActivityEvent/start/' + activity.entityUuid + '/' + activity.userId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const continueLearningActivity = (activity) => {
  return HTTP().put('learningActivityEvent/continue/' + activity.entityUuid + '/' + activity.userId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const stopLearningActivity = (activity) => {
  return HTTP().put('learningActivityEvent/stop/' + activity.entityUuid + '/' + activity.userId + '/' + activity.rating)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getEntityCompetencySummary = (courseId, entityId) => {
  return HTTP().get('competency/' + courseId + '/competencySummary/entity/' + entityId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getEntityActivity = (courseId, entityId) => {
  return HTTP().get('competency/' + courseId + '/competencySummary/entity/' + entityId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCompetencySummaryForClass = (courseId) => {
  var url = 'competency/' + courseId + '/competencySummary/class'
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getChildrenCompetencySummaryForClass = (courseId, competencyId) => {
  var url = 'competency/' + courseId + '/competencySummary/class/' + competencyId + '/children/withparent'
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getChildrenCompetencySummaryForLearner = (courseId, competencyId) => {
  var url = 'competency/' + courseId + '/competencySummary/class/' + competencyId + '/children/withparent/learner'
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getObservationForClass = (courseId, competencyId, allCourses) => {
  var url = 'competency/competencySummary/observation?courseIds=' + courseId
  if(allCourses){
    url = 'competency/competencySummary/observation/all?courseIds=' + courseId
  }
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getDignosticReportForClass = (courseId, assessmentId) => {
  var url = 'dignosticReport/course/'+courseId+'/assessment/'+assessmentId
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const getAllDiagnosticTests = (courseId) => {
  var url = 'dignosticReport/course/' + courseId +'/alldtkc'
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getObservationForLearner = (courseId) => {
  var url = 'competency/competencySummary/observation/learner?courseIds=' + courseId
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getFullClassSummary = (courseId) => {
  var url = 'class/' + courseId + '/all'
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const saveCourseCompetencyCompleted = (courseId, userId ) => {
  var url = 'competency/competencySummary/mark/'+userId+'/course/'+courseId
  return HTTP().put(url).then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const saveCourse = (data) => {
  var url = 'deliverycontext/'
  if (data.uuid) {
    url += data.uuid
  }
  url += '?parentSpaceId=' + data.owningLibraryId
  return HTTP().put(url, data).then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const autonumber = (data) => {
  var url = 'deliverycontext/'
  if (data.uuid) {
    url += data.uuid
  }
  url += '/autonumber'
  return HTTP().put(url, data).then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCopyCourseDetail = (uuid) => {
  return HTTP().get('deliverycontext/' + uuid + '/forCopy')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deleteCourse = (uuid) => {
  return HTTP().delete('deliverycontext/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const purgeCompetencyLogicMessage = (uuid) => {
  return HTTP().delete('competencyLogic/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const updateAttemptScoreBySessionId = (sessionId, newScore) => {
  return HTTP().put('attempt/override/score/' + sessionId+'/'+newScore)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const deleteAttemptBySessionId = (sessionId) => {
  return HTTP().delete('attempt/delete/' + sessionId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deleteMultipleCourses = (uuids) => {
  return HTTP().delete('deliverycontext/multiple?uuids=' + uuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const archiveMultipleCourses = (uuids, flag) => {
  return HTTP().put('deliverycontext/archive/multiple?uuids=' + uuids+'&archive='+flag)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const airMultipleCourses = (uuids, flag) => {
  return HTTP().put('deliverycontext/air/multiple?uuids=' + uuids+'&flag='+flag)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deleteMultipleCompetencies = (uuids) => {
  return HTTP().delete('competency/multiple?uuids=' + uuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getPLOs = () => {
  return HTTP().get('competency/plo')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const applyCompetencyTreeToCourse = (courseId, competencyId, version) => {
  var url = 'deliverycontext/' + courseId + '/applyCompetency/' + competencyId
  if(version){
    url = url+'/version/'+version
  }
  return HTTP().put(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getEnrolledStudentUsers = (parentSpaceId) => {
  var url = 'user/search?parentSpaceId=' + parentSpaceId + '&role=Student&page=0&count=99999'
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getEnrolledCuratorUsers = (parentSpaceId) => {
  var url = 'user/search?parentSpaceId=' + parentSpaceId + '&role=Curator&page=0&count=99999'
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getEnrolledInstructorUsers = (parentSpaceId) => {
  var url = 'user/search?parentSpaceId=' + parentSpaceId + '&role=Instructor|Instructor%20%26%20Admin&page=0&count=99999'
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getEnrolledObserverUsers = (parentSpaceId) => {
  var url = 'user/search?parentSpaceId=' + parentSpaceId + '&role=Observer&page=0&count=99999'
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const enrollUsers = (data) => {
  var url = 'deliverycontext/' + data.uuid + '/enrollmentInCourse/'
  return HTTP().put(url, data.userUuidList)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getAllCourses = (page, count, title, archive, itemReport, version, masterCourseId) => {
  var url = 'deliverycontext/manageCourse?page=' + page + '&count=' + count
  if (title) {
    url += '&title=' + title
  }
  if (archive) {
    url += '&archive=' + archive
  }
  if (itemReport) {
    url += '&itemReport=' + itemReport
  }
  if(version){
    url += '&version=' + version
  }
  if(masterCourseId){
    url += '&masterCourseId=' + masterCourseId
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const getMyCourses = (page, count, title) => {
  var url = 'deliverycontext/enrolled/all?page=' + page + '&count=' + count
  if (title) {
    url += '&title=' + title
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const isCompetencyExists = (code) => {
  return HTTP().get('competency/isExists/' + code)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getBlackboardCourseAccess = (lmsCourseId) => {
  return HTTP().get('blackboardActivity/courseActivity/' + lmsCourseId + '?activityType=COURSE_ACCESS')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getBlackboardContentAccess = (lmsCourseId) => {
  return HTTP().get('blackboardActivity/courseActivity/' + lmsCourseId + '?activityType=CONTENT_ACCESS')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getBlackboardGradeActivity = (lmsCourseId) => {
  return HTTP().get('blackboardActivity/gradeActivity/' + lmsCourseId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getBlackboardAggregatedGradeActivity = (lmsCourseId) => {
  return HTTP().get('blackboardActivity/aggregatedGradeActivity/' + lmsCourseId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getBlackboardAnnouncements = (lmsCourseId) => {
  return HTTP().get('blackboardActivity/announcement?lmsCourseId=' + lmsCourseId + '&announcementType=C')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const uploadCompetency = (data, success, error) => {
  return HTTP().post('competency/upload', data)
  .then(res => {
    success(res.data)
  })
  .catch(e => {
    console.log(e)
    error(e)
  })
}

export const getUnloackQuest = (userId, courseId, contentId) => {
  return HTTP().get('suggest/user/' + userId + '/course/' + courseId + '/content/' + contentId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const doCsvUploadForCourseSection = (institutionId, userId, fileData) => {
  if (!institutionId || !userId) {
    return
  }
  let url = '/deliverycontext/createCourseViaCsv?parentSpaceId=' + institutionId + '&userId=' + userId
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const doClassSummaryExport = (courseId, competencyId) => {
  if (!courseId || !competencyId) {
    return
  }
  let url = '/competency/' + courseId + '/competencySummary/class/' + competencyId + '/children/withparent/csvExport'
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const doObservationExport = (courseId, competencyId, allCourses, status) => {
  let url = '/competency/observation/csvExport?courseIds=' + courseId +'&allCourses='+allCourses+'&status='+status
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const doDignosticReportExport = (courseId, assessmentId) => {
  let url = 'dignosticReport/course/'+courseId+'/assessment/'+assessmentId+'/csvExport'
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const doCourseTreeExport = (courseId) => {
  let url = '/deliverycontext/ctree/csvExport/'+ courseId
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const doExportCourseConversionToCsv = (courseId) => {
  let url = '/deliverycontext/extract/dryrun/'+ courseId
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const doUnbundleMCFromCourse = (courseId,subject,moduleName) => {
  let url = '/deliverycontext/extract/mc/'+ courseId+'/'+subject+'/'+moduleName
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const doExportLTIAssignmentGrade = (courseId) => {
  let url = '/deliverycontext/export/lti/assignment/'+ courseId
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const convertToModularCourse = (courseId,subject,moduleName) => {
  let url = '/deliverycontext/convert/modular/'+ courseId+'/'+subject+'/'+moduleName
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const addOrDropStudentFromClassAverage = (courseId, userId, action) => {
  return HTTP().put('deliverycontext/' + courseId + '/' + action + '/' + userId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const updateCourseStatusForUser = (courseId, userId, status) => {
  return HTTP().put('deliverycontext/' + courseId + '/updateStatus/' + userId + '/' + status)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const addMissingSummaries = (courseId) => {
  return HTTP().put('competency//add/missing/' + courseId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const updateCourseStatusForUsers = (courseId, data) => {
  return HTTP().put('deliverycontext/' + courseId + '/updateStatus/bulk', data)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCoursesWithChannel = () => {
  return HTTP().get('deliverycontext/coursesWithChannel')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getKCMessage = (entityId, courseType) => {
  return HTTP().get('competency/KCMessage/' + entityId + '/' + courseType)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const fetchCompetencyLogicMessage = (courseId, competencyId, type) => {
  return HTTP().get('competencyLogic/course/'+courseId+'/type/'+type+'/competencyId/'+competencyId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const updateCompetencyLogicMessage = (obj) => {
  return HTTP().put('competencyLogic/update/', obj)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}
export const getKCDescription = (entityId, courseType, courseId) => {
  return HTTP().get('competency/KCDescription/' + entityId + '/' + courseType + '/' + courseId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const postUploadMicroCompetencyMappingCsvFile = (fileData) => {
  if (!fileData) {
    return
  }
  let url = '/deliverycontext/mcMappingCsv'
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./src/app/course/api.js